/* eslint-disable no-alert */
import { request } from 'root/common/request';
import envUtil from 'root/common/util/env';

function getQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}
// 广东联通的客服
export function getGDMobileServiceUrl() {
    return `http://sh-p3.ntalker.com/downt/t2d/chat.php?v=2020.04.30&siteid=fh_1000&settingid=fh_1000_1596014860164&baseuri=http%3A%2F%2Fdl.ntalker.com%2Fjs%2Fb2b%2F&mobile=1&ref=${window.encodeURIComponent(
        location.href
    )}&header=0`;
}

/**
 * 请求客服链接
 * @param {*} data
 * @param {*} opts
 * @returns
 */
export async function requestKfLink(data, opts = {}) {
    const host = window.location.host;
    let env = '';
    if (/box/.test(host)) {
        env = 'box-';
    } else if (/test/.test(host)) {
        env = 'test-';
    }
    const domain = `https://${env}customer-api.chuxingyouhui.com`;
    const res = await request({
        url: domain + '/ccm/chat_url',
        method: 'POST',
        loadingText: '加载中，请稍等...',
        isNeedLoading: false,
        data,
        ...opts,
        isNeedToken: false,
    });
    if (!res) {
        return null;
    }
    // 302 或者异常 用回旧链接
    if (res && (res.code == 302 || res.code != 200)) {
        return null;
    }
    return res.data;
}

async function getKfLink(options = {}) {
    let biz = options.biz || '';
    let ccmFlag = 'H5';
    let entrance = options.entrance || '';
    let appId = '';
    const isWX = /micromessenger/.test(navigator.userAgent.toLowerCase());
    const isApp = /black/.test(navigator.userAgent.toLowerCase());
    const isAliClient = /alipayclient/.test(navigator.userAgent.toLowerCase());
    const isWechatMiniProgram = envUtil.isWechatMiniProgram;
    const userId =
        getQueryString('kfUUID') ||
        window.localStorage.getItem('member_id') ||
        window.localStorage.getItem('guid') ||
        '';

    // 只有小程序环境下需要传入appId
    if (envUtil.isWechatMiniProgram || envUtil.isAliPayMini) {
        appId = getQueryString('app_id') || window.localStorage.getItem('mini-appId') || '';
    }
    if (appId) {
        console.log(appId);
        window.localStorage.setItem('mini-appId', appId);
    }

    if (isApp) {
        ccmFlag = 'APP';
    } else if (isWX) {
        if (isWechatMiniProgram) {
            ccmFlag = 'WX_MINI';
        } else {
            ccmFlag = 'WX_H5';
        }
    } else if (isAliClient) {
        ccmFlag = 'ZFB_H5';
        if (appId) {
            ccmFlag = 'ZFB_MINI';
        }
    } else {
        ccmFlag = 'H5';
    }

    let requestData = {
        appInfo: {
            appId: appId || '',
            browser: navigator.userAgent,
        },
        ccmFlag: {
            biz: biz,
            entrance: entrance,
            platform: ccmFlag,
        },
        userInfo: {
            userId: userId || 0,
        },
    };
    // 如果是微信小程序跳转进来
    if (isWechatMiniProgram && localStorage.getItem('miniEnv')) {
        const miniInfo = JSON.parse(localStorage.getItem('miniEnv')) || {};
        requestData['appInfo']['appId'] = miniInfo.appId || requestData['appInfo']['appId'] || '';
        requestData['userInfo']['openId'] = miniInfo.openId;
        requestData['userInfo']['unionId'] = miniInfo.unionId;
    }
    if (options.appId) {
        requestData['appInfo']['appId'] = options.appId;
    }

    if (options.entryType) {
        // 11.12，详情页面和订单页面进入云客服加商品参数，订单参数
        requestData[options.entryType] = options.servicePrms;
    }
    const url = await requestKfLink(requestData, options);

    return url;
}

export { getKfLink };
